export function fmtUsd(n) {
  const x = Number(n || 0);
  return `$${x.toFixed(2)}`;
}

export function fmtNum(n, dp = 2) {
  const x = Number(n || 0);
  return x.toFixed(dp);
}

export function fmtDate(iso) {
  if (!iso) return "";
  const d = new Date(iso);
  return d.toLocaleString();
}